import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'

export type FormValues = z.infer<typeof FormSchema>
const FormSchema = z
  .object({
    minSpend: z.number(),
    maxSpend: z.number(),
    name: z.string().min(1, 'Name is required'),
    includeExpiredFans: z.boolean(),
  })
  .refine((data) => data.minSpend <= data.maxSpend, {
    message: 'Min Spend should be less than Max Spend',
    path: ['minSpend'],
  })
  .refine((data) => data.minSpend <= data.maxSpend, {
    message: 'Max Spend should be more than Min Spend',
    path: ['maxSpend'],
  })

export const initialValues: FormValues = {
  minSpend: 0,
  maxSpend: 0,
  name: '',
  includeExpiredFans: true,
}

export const resolver = zodResolver(FormSchema)
